// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfigHeader_container__1tqhh","selector":"ConfigHeader_selector__1WvPw","input":"ConfigHeader_input__ZMekv"};